import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// @ts-expect-error
import de_translations from "../../../config/locales/de.yml";
// @ts-expect-error
import fr_translations from "../../../config/locales/fr.yml";
// @ts-expect-error
import it_translations from "../../../config/locales/it.yml";
import type Resources from "../types/resources";

export const resources = {
  de: { translation: (de_translations as Resources["de"]).de },
  fr: { translation: (fr_translations as Resources["fr"]).fr },
  it: { translation: (it_translations as Resources["it"]).it },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "de",
  lng: document?.documentElement?.lang?.split("-")?.[0] || "de",
  debug: false,
  keySeparator: ".",
  nsSeparator: false,

  interpolation: {
    escapeValue: false, // react already safes from xss,
    prefix: "%{",
    suffix: "}",
  },
});

export default i18n;

export const formatDate = (date: string | Date) =>
  new Intl.DateTimeFormat(i18n.language, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(date));

export const formatDateTime = (date: string | Date) =>
  new Intl.DateTimeFormat(i18n.language, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
  }).format(new Date(date));
